import { withHook } from 'utils/withHook';
import { useRevieNotesState } from 'containers/ReviewNotes/logic/useReviewNotesState';
import { ReviewNotesView } from 'containers/ReviewNotes/view/ReviewNotesView';

export const ReviewNotes = withHook(useRevieNotesState)(ReviewNotesView);
